import React, { useEffect, useState } from "react";

/**
 * AdminGate
 * - Controlla se esiste una chiave admin valida (in localStorage).
 * - Se valida → rende i children.
 * - Se non valida → chiede password e la verifica contro /api/admin/ping.
 *
 * NB: su Cloudflare Pages devi avere la variabile ENV "ADMIN_KEY" impostata (Production + Preview).
 */

const STORAGE_KEY = "RB_ADMIN_KEY";

async function ping(key) {
  try {
    const r = await fetch("/api/admin/ping", {
      method: "GET",
      headers: { "x-admin-key": key || "" },
    });
    return r.ok;
  } catch {
    return false;
  }
}

export default function AdminGate({ children }) {
  const [status, setStatus] = useState("checking"); // checking | ask | ok
  const [pwd, setPwd] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && (await ping(saved))) {
        setStatus("ok");
      } else {
        setStatus("ask");
      }
    })();
  }, []);

  async function onSubmit(e) {
    e?.preventDefault();
    setError("");
    if (!pwd) {
      setError("Inserisci la password admin.");
      return;
    }
    const ok = await ping(pwd);
    if (ok) {
      localStorage.setItem(STORAGE_KEY, pwd);
      setStatus("ok");
    } else {
      setError("Password non valida.");
    }
  }

  if (status === "ok") return <>{children}</>;

  // schermata password
  return (
    <div className="min-h-[60vh] w-full flex items-center justify-center p-4">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm rounded-xl border bg-white shadow p-6 space-y-4"
      >
        <h2 className="text-xl font-semibold">Area riservata</h2>
        <p className="text-sm text-gray-600">
          Inserisci la <b>password admin</b> per accedere.
        </p>

        <input
          type="password"
          className="w-full border rounded-md px-3 py-2"
          placeholder="Password admin"
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
          autoFocus
        />

        {error && <div className="text-sm text-red-600">{error}</div>}

        <div className="flex items-center gap-2">
          <button
            type="submit"
            className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700"
          >
            Entra
          </button>
          <button
            type="button"
            className="px-3 py-2 rounded-md border"
            onClick={() => {
              localStorage.removeItem(STORAGE_KEY);
              setPwd("");
              setError("");
            }}
          >
            Reset
          </button>
        </div>

        <div className="text-xs text-gray-500">
          {status === "checking" ? "Verifica in corso…" : "Protetto da password."}
        </div>
      </form>
    </div>
  );
}
